// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StructureXPathes_StructureXPathes__3p9Xf {
  height: 100%;
  background: #FFFFFF;
}
.StructureXPathes_StructureXPathes__3p9Xf .StructureXPathes_subHeader__dYEj1 {
  width: 100%;
  height: 4vh;
  padding: 4px 0;
  text-align: right;
  background: #F0F2F5;
}
.StructureXPathes_StructureXPathes__3p9Xf .StructureXPathes_subHeader__dYEj1 button {
  background: #F0F2F5;
}
.StructureXPathes_StructureXPathes__3p9Xf .StructureXPathes_header__\\+3WbZ {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
}
.StructureXPathes_StructureXPathes__3p9Xf .StructureXPathes_header__\\+3WbZ .StructureXPathes_searchField__9QqTH {
  flex: 0.8 1;
}
.StructureXPathes_StructureXPathes__3p9Xf .StructureXPathes_header__\\+3WbZ .StructureXPathes_exploreBtns__S7AKP {
  display: flex;
  gap: 8px;
}
.StructureXPathes_StructureXPathes__3p9Xf .StructureXPathes_content__xnAWy {
  height: 58vh;
  overflow: hidden;
}
.StructureXPathes_StructureXPathes__3p9Xf .StructureXPathes_content__xnAWy .StructureXPathes_contentControls__TpUsK {
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 999;
  padding: 16px 24px;
}
.StructureXPathes_StructureXPathes__3p9Xf .StructureXPathes_content__xnAWy .StructureXPathes_contentControls__TpUsK .StructureXPathes_leftBtns__JhBQX button {
  padding: 0 2px;
}
.StructureXPathes_StructureXPathes__3p9Xf .StructureXPathes_content__xnAWy .StructureXPathes_contentControls__TpUsK .StructureXPathes_rightBtns__ItDz7,
.StructureXPathes_StructureXPathes__3p9Xf .StructureXPathes_content__xnAWy .StructureXPathes_contentControls__TpUsK .StructureXPathes_leftBtns__JhBQX {
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/tables/components/DocumentProcessing/TreatmentCDA/StructureXPathes/StructureXPathes.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AACJ;AACI;EACE,mBAAA;AACN;AAIE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAFJ;AAII;EACE,WAAA;AAFN;AAKI;EACE,aAAA;EACA,QAAA;AAHN;AAOE;EACE,YAAA;EACA,gBAAA;AALJ;AAOI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AALN;AAQQ;EACE,cAAA;AANV;AAUM;;EAEE,aAAA;EACA,SAAA;AARR","sourcesContent":[".StructureXPathes {\n  height: 100%;\n  background: #FFFFFF;\n\n  .subHeader {\n    width: 100%;\n    height: 4vh;\n    padding: 4px 0;\n    text-align: right;\n    background: #F0F2F5;\n\n    button {\n      background: #F0F2F5;\n    }\n  }\n\n\n  .header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 24px;\n\n    .searchField {\n      flex: 0.8;\n    }\n\n    .exploreBtns {\n      display: flex;\n      gap: 8px;\n    }\n  }\n\n  .content {\n    height: 58vh;\n    overflow: hidden;\n\n    .contentControls {\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      position: sticky;\n      top: 0;\n      background: #fff;\n      z-index: 999;\n      padding: 16px 24px;\n\n      .leftBtns {\n        button {\n          padding: 0 2px;\n        }\n      }\n\n      .rightBtns,\n      .leftBtns {\n        display: flex;\n        gap: 16px;\n      }\n    }\n  }\n\n  //.content::-webkit-scrollbar {\n  //  width: 4px !important;\n  //  height: 4px !important;\n  //}\n  //\n  //.content::-webkit-scrollbar-thumb {\n  //  background-color: #04867a;\n  //  border-radius: 50px;\n  //  width: 2px;\n  //}\n  //\n  //.content::-webkit-scrollbar-track {\n  //  background: #e2e4e7;\n  //}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"StructureXPathes": `StructureXPathes_StructureXPathes__3p9Xf`,
	"subHeader": `StructureXPathes_subHeader__dYEj1`,
	"header": `StructureXPathes_header__+3WbZ`,
	"searchField": `StructureXPathes_searchField__9QqTH`,
	"exploreBtns": `StructureXPathes_exploreBtns__S7AKP`,
	"content": `StructureXPathes_content__xnAWy`,
	"contentControls": `StructureXPathes_contentControls__TpUsK`,
	"leftBtns": `StructureXPathes_leftBtns__JhBQX`,
	"rightBtns": `StructureXPathes_rightBtns__ItDz7`
};
export default ___CSS_LOADER_EXPORT___;
